<svelte:head>
  <title>Create template | A Good Thing</title>
</svelte:head>

<!-- Main container -->
<h2 class="title">Create email template</h2>

<!-- form -->

<!-- apply? -->

<!-- toast to show saved -->

{#if showToast}
  <div class="notification is-success">
    <button class="delete" on:click={() => showToast = false} />
    Template created
  </div>
{/if}

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="id" class="label">ID</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="id"
          class="input"
          type="text"
          placeholder=""
          bind:value={id} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="subject" class="label">Subject</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="subject"
          class="input"
          type="text"
          placeholder=""
          bind:value={data.subject} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="text" class="label">Text</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <textarea
          id="text"
          class="textarea"
          placeholder="10 lines of textarea"
          rows="10"
          bind:value={data.text} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="html" class="label">HTML</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <textarea
          id="html"
          class="textarea"
          placeholder="10 lines of textarea"
          rows="10"
          bind:value={data.html} />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <button
          class="button is-primary"
          on:click={() => create()}>Save</button>
      </div>
    </div>
  </div>
</div>


<script lang="ts">
  import _ from "lodash";
  import { goto } from "@sveltech/routify";

  let id :string;

  let data = {
    subject: "",
    text: "",
    html: "",
  };

  let showToast = false;

  let firebase = window.firebase;

  async function create() {
    await firebase.firestore().collection("_mail_templates").doc(id).set(data);

    $goto("../../email_templates/");
  }
</script>
